<template>
  <div class="couponContent">
    <el-tabs v-model="activeName">
      <el-tab-pane v-if="menusList.find(data => data.iDenTi === 'beauty-3-yhqhx')" label="优惠券核销" name="second">
        <iframe class="couponIframe" :src="getUrl('1')"></iframe>
      </el-tab-pane>
      <el-tab-pane v-if="menusList.find(data => data.iDenTi === 'beauty-3-yhqpq')" label="派券" name="first">
        <iframe id="iframe" class="couponIframe" :src="getUrl('2')"></iframe>
      </el-tab-pane>
      <el-tab-pane v-if="menusList.find(data => data.iDenTi === 'beauty-3-yhqhxlb')" label="核销列表" name="third">
        <iframe class="couponIframe" :src="getUrl('3')"></iframe>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menusList: [],
      activeName: 'second'
    };
  },
  deactivated() {
    window.removeEventListener('message', () => {});
    this.openMemberDialog(false);
  },
  mounted() {
    this.menusList = JSON.parse(sessionStorage.getItem('menusList'));
    this.activeName = this.$route.params.activeName;
    if (this.activeName === 'first') {
      this.getUrl('2');
    }
    window.addEventListener('message', (e) => {
      if (['openMask()', 'closeMask()'].includes(e.data)) {
        console.log(e.data == 'openMask()');
        this.openMemberDialog(e.data == 'openMask()');
      }
      // eslint-disable-next-line no-eval
      eval(e.data);
    }, false);
  },
  methods: {
    // handleClick(a) {
    //   console.log('this.activeName', this.activeName, a);
    // },
    openMemberDialog(val) {
      if (val) {
        $('#couponMask').css('display', '');
      } else {
        $('#couponMask').css('display', 'none');
      }
    },
    // 判断环境
    judgeEnvironment() {
      const { href } = window.location;
      if (href.includes('duofriend')) return 'https://member.duofriend.com';
      if (href.includes('https://nb')) return 'https://nbmember.deeptel.com.cn';
      return 'https://member.deeptel.com.cn';
    },
    getUrl(val) {
      return `${this.judgeEnvironment()}/html/duofencard/pc/index.html#/couponVerification?getType=12&activeName=${val || 1}&loginToken=${window.sessionStorage.token}`;
    }
  }
};
</script>

<style lang="less" scoped>
.couponContent {
  position: fixed;
  margin-top: -6px;
  .couponIframe {
    margin-left: -55px;
    width: calc(100% + 109px);
    border: 0;
    position: relative;
    height: calc(100vh - 103px);
  }
}
</style>

<style>
.authority .mainContain {
  margin: 0 !important;
}
</style>
